"use client";

import { useRef } from "react";
import { useFormStatus } from "react-dom";

import { Button } from "@/components/button/button.component";

import { ProductLineItemModel } from "@/lib/basket/productLineItem.model";

import { clearQuizData } from "@/app/blu/quiz/utils/quizStorage";
import { useAddToCartAnalytics } from "@/hooks/useAddToCartAnalytics";
import { GetProductQueryResult } from "@/sanity.types";

import { ProductReplaceKitModal } from "../productReplaceKitModel/productReplaceKitModal.component";

export const ProductMiniCartActionClient = ({
  primary,
  secondary,
  product,
  accessories,
  existingKits,
  kits,
  monitoring,
  formId = "mini-cart-to-cart-form",
  quizResetSlug,
}: ProductMiniCartActionClientProps) => {
  const { pending } = useFormStatus();
  const confirmationModal = useRef<HTMLDialogElement>(null);
  const fireAddToCartAnalytics = useAddToCartAnalytics({
    kits,
    accessories,
    monitoring,
  });
  const resetQuizData = () => {
    if (quizResetSlug) clearQuizData(quizResetSlug);
  };
  const submitAction = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    const differentKit = existingKits?.find(
      (kit) => kit.productId !== product?.id,
    );
    // Check if the basket contains a different kit
    if (differentKit) {
      confirmationModal?.current?.showModal();
      return;
    }
    // Get product form
    const productForm = document.getElementById(formId) as HTMLFormElement;
    // Submit product form
    fireAddToCartAnalytics();
    resetQuizData();
    productForm?.requestSubmit();
  };
  return (
    <>
      <Button
        type="button"
        data-testid="product-mini-cart-add-to-cart"
        primary={primary}
        secondary={secondary}
        className="w-full px-6 lg:w-fit"
        loading={pending}
        disabled={pending}
        onClick={submitAction}>
        Add To Cart
      </Button>
      <ProductReplaceKitModal
        ref={confirmationModal}
        formId={formId}
        onConfirm={() => {
          fireAddToCartAnalytics();
          resetQuizData();
        }}
      />
    </>
  );
};

export type ProductMiniCartActionClientProps = {
  primary?: boolean;
  secondary?: boolean;
  product: GetProductQueryResult;
  kits: ProductLineItemModel[];
  existingKits: ProductLineItemModel[];
  accessories: ProductLineItemModel[];
  monitoring: ProductLineItemModel | null;
  formId?: string;
  quizResetSlug?: string;
};
